module.exports = __webpack_public_path__ + "img/full7-min.117ea4c2.png";